import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { IoInformationCircle, IoSearch } from "react-icons/io5";
import { CellContext, ColumnDef, RowSelectionState } from "@tanstack/react-table";

import { RootState } from "../../redux/store";

import { rupiahFormat } from "../../lib/utils";

import ShippingDetails from "./ShippingDetails";
import { ShippingTableColumnData } from "./ShippingTypes";
import { fetchShippings, fetchShippingsPayload } from "./ShippingServices";

import Modal from "../../components/Modal";
import { Spinner } from "../../components/ui/spinner";
import { Checkbox } from "../../components/ui/checkbox";
import { AlertPropsType } from "../../components/ui/alert";
import ReusableTable from "../../components/common/ReactTable";

// type SelectState = {
//   value: string;
//   label: string;
// };

// const CITY_OPTIONS: SelectState[] = [
//   { value: "all", label: "Semua Kota" },
//   { value: "mdn", label: "Medan" },
//   { value: "duri", label: "Duri" },
//   { value: "pku", label: "Pekanbaru" },
//   { value: "krc", label: "Kerinci" }
// ];

// const PAYMENT_STATUS_OPTIONS: SelectState[] = [
//   { value: "all", label: "Semua" },
//   { value: "paid", label: "Lunas" },
//   { value: "unpaid", label: "Belum Bayar" }
// ];

const ShippingListTable = () => {
  // const { user } = useSelector((state: RootState) => state.auth);
  const deliveryState = useSelector((state: RootState) => state.delivery);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<AlertPropsType | null>(null);

  const [totalShippings, setTotalShippings] = useState(0);
  const [tableData, setTableData] = useState<any>([]);
  const [filters, setFilters] = useState<any>([
    // { id: "status_code", value: "CONFIRMED" },
  ]);

  // FILTER FORM VALUE
  // const [selectedOriginCity, setSelectedOriginCity] = useState<SelectState>({ value: "all", label: "Semua Kota" });
  // const [selectedDestinationCity, setSelectedDestinationCity] = useState<SelectState>({ value: "all", label: "Semua Kota" });
  // const [selectedPaymentStatus, setSelectedPaymentStatus] = useState<SelectState>({ value: "all", label: "Semua" });
  // const [selectedShippingDate, setSelectedShippingDate] = useState<Date | undefined>(new Date());
  
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  // Derive selected row data from rowSelection + tableData
  // const selectedRows: ShippingTableColumnData[] = Object.keys(rowSelection)
  //   .filter((key) => rowSelection[key])
  //   .map((index) => tableData[Number(index)]);

  const [selectedShippingData, setSelectedShippingData] = useState<ShippingTableColumnData | null>(null);
  const [isOpenEditModal, setIsOpenEditModal] = useState<boolean>(false);
  const [isOpenDetailsModal, setIsOpenDetailsModal] = useState<boolean>(false);

  const [shippingNumberInput, setShippingNumberInput] = useState<string>("");

  useEffect(() => {
    if(deliveryState.delivery_number) {
      fetchData(deliveryState.delivery_number);
    };

    return () => { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const fetchData = async (delivery_number: string, filter?: any) => {
    setIsLoading(true);
    try {
      const payload: fetchShippingsPayload = {
        filters: filter || [
          { id: "delivery_number", value: delivery_number }
        ],
        sort: [],
        pagination: {
          limit: 50,
          activePage: 0
        }
      };
      const response = await fetchShippings(payload);
      const { status, message } = response;
      if (status === 200) {
        setTableData(message.data);
        setTotalShippings(message.totalData);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setAlert({
          variant: "error",
          title: "Terjadi kesalahan",
          message
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
      setAlert({
        variant: "error",
        title: "Terjadi kesalahan",
        message: ""
      });
    }
  };

  const shippingsTableColumn: ColumnDef<ShippingTableColumnData>[] = [
    // {
    //   id: "select",
    //   size: 10,
    //   header: ({ table }) => (
    //     <Checkbox
    //       checked={
    //         table.getIsAllPageRowsSelected() ||
    //         (table.getIsSomePageRowsSelected() && "indeterminate")
    //       }
    //       onCheckedChange={(value: any) => table.toggleAllPageRowsSelected(!!value)}
    //       aria-label="Select all"
    //       className="ml-2"
    //     />
    //   ),
    //   cell: ({ row }) => (
    //     <Checkbox
    //       checked={row.getIsSelected()}
    //       onCheckedChange={(value: any) => row.toggleSelected(!!value)}
    //       aria-label="Select row"
    //       className="ml-2"
    //     />
    //   ),
    //   enableSorting: false,
    //   enableHiding: false,
    // },
    {
      accessorKey: 'No.',
      enableResizing: false,
      size: 10,
      cell: ({ row }: any) => {
        return (
          <div className='text-center text-xs'>
            {Number(row.id) + 1}
          </div>
        )
      }
    },
    {
      accessorKey: 'origin_customer_data.sender_name',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Nama Pengirim</p>
        </div>
      ),
      size: 160,
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { origin_customer_data } = row.original;
        return (
          <div className="pe-2">
            <p className='capitalize font-bold text-xs'>{origin_customer_data.sender_name}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'shipping_number',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>No. Resi</p>
        </div>
      ),
      size: 180,
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { shipping_number } = row.original;
        return (
          <div>
            <p className='capitalize font-bold text-xs'>{shipping_number}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'destination_customer_data.sender_name',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Nama Penerima</p>
        </div>
      ),
      size: 160,
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { destination_customer_data } = row.original;
        return (
          <div className="pe-2">
            <p className='capitalize font-bold text-xs'>{destination_customer_data.recipient_name}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'origin_office_id.city',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Asal</p>
        </div>
      ),
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { origin_office_id } = row.original;
        return (
          <div>
            <p className='uppercase w-full text-xs font-bold'>{origin_office_id.city}</p>
            <p className='uppercase w-full text-xs font-light'>{origin_office_id.branch_name}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'destination_office_id.city',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Tujuan</p>
        </div>
      ),
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { destination_office_id } = row.original;
        return (
          <div>
            <p className='uppercase w-full text-xs font-bold'>{destination_office_id.city}</p>
            <p className='uppercase w-full text-xs font-light'>{destination_office_id.branch_name}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'status_code',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p className="">Status Kirim</p>
        </div>
      ),
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { status_code } = row.original;
        return (
          <div className="">
            <p className={`w-full font-bold text-xs ${status_code === "CANCELED" ? "text-red-600" : "text-green-600"}`}>{status_code}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'quantity',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Jumlah</p>
        </div>
      ),
      size: 80,
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { quantity, item_unit } = row.original;
        return (
          <div>
            <p className='w-full font-bold text-xs'>{quantity} {item_unit}</p>
          </div>
        )
      }
    },

    {
      accessorKey: 'total_price',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p>Total Harga</p>
        </div>
      ),
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { total_price } = row.original;
        return (
          <div>
            <p className='w-full font-bold text-xs'>Rp {rupiahFormat(total_price)}</p>
          </div>
        )
      }
    },
    {
      accessorKey: 'payment_status',
      enableResizing: false,
      header: () => (
        <div className='text-left text-xs'>
          <p className="">Status Bayar</p>
        </div>
      ),
      cell: ({ row }: CellContext<ShippingTableColumnData, unknown>) => {
        const { payment_status } = row.original;
        return (
          <div className="">
            <p className={`w-full font-bold text-xs ${payment_status === "paid" ? "text-green-600" : "text-red-600"}`}>{payment_status === "paid" ? "LUNAS" : "BB"}</p>
          </div>
        )
      }
    },
    {
      accessorKey: '_id',
      header: '',
      cell: ({ row }) => {
        const { original } = row;
        return (
          <div className='flex items-center justify-center gap-2 rounded-lg'>
            <button
              className='flex items-center gap-1 py-2 px-4 bg-main-blue hover:bg-blue-700 text-white rounded-lg'
              onClick={() => {
                setSelectedShippingData(original);
                setIsOpenEditModal(false);
                setIsOpenDetailsModal(true);
              }}
            >
              <IoInformationCircle />
              Lihat
            </button>
            <button
              className='flex items-center justify-center gap-1 h-10 w-10 btn-border-blue text-secondary-blue hover:bg-secondary-blue hover:text-white transition-all ease-in-out duration-300 rounded-lg'
              onClick={() => {
                setSelectedShippingData(original);
                setIsOpenEditModal(true);
                setIsOpenDetailsModal(false);
              }}
            >
              <CiEdit size={20} />
            </button>
          </div>
        )
      }
    }
  ];

  const onClickSearch = () => {
    const newFilter = [...filters, { id: "shipping_number", value: shippingNumberInput }];
    setFilters(newFilter);
    fetchData(deliveryState.delivery_number, newFilter);
  };

  let totalIncome = 0;
  let paidIncome = 0;
  let creditIncome = 0;
  
  if(tableData.length > 0) {
    totalIncome = tableData.reduce((accumulator: any, item: any) => accumulator + item.total_price, 0);
    paidIncome = tableData.filter((item: any) => item.payment_status.toLowerCase() === "paid").reduce((accumulator: any, item: any) => accumulator + item.total_price, 0);
    creditIncome = tableData.filter((item: any) => item.payment_status.toLowerCase() === "unpaid").reduce((accumulator: any, item: any) => accumulator + item.total_price, 0);
  }

  return (
    <div className="bg-white rounded-xl p-4">
      <div className="flex items-end justify-between">
        <div>
          <div className="flex items-center gap-2 min-w-[50px] text-sm mt-1">
            <input
              id="shippingNumberInput"
              name="shippingNumberInput"
              type="text"
              value={shippingNumberInput}
              placeholder={"Masukkan no. resi"}
              onChange={(e) => {
                setShippingNumberInput(e.target.value);
                if (e.target.value === "") {
                  setFilters([...filters, { id: "shipping_number", value: e.target.value }]);
                  fetchData(deliveryState.delivery_number);
                };
              }}
              disabled={isLoading}
              className='tracking-tight font-semibold border border-gray-400 py-2 px-2.5 flex-1 rounded-xl bg-neutral-100 text-black disabled:bg-neutral-300 disabled:text-neutral-700 focus:outline-1 focus-visible:outline-none w-full'
            />
            <button onClick={onClickSearch} className="bg-secondary-blue hover:!bg-sky-400 transition-all ease-in-out duration-300 text-white py-[10px] px-4 pe-5 rounded-xl font-bold flex items-center gap-1 text-sm">
              <IoSearch size={12} />
              Cari
            </button>
          </div>
        </div>
        <div>
          <p className="cursor-default">Total Kiriman : <strong>{totalShippings}</strong> paket</p>
        </div>
      </div>
      <div className="flex items-center justify-between mt-5 px-4 py-3 bg-gray-200 rounded-xl">
        <div>
          <h2 className="capitalize">Tunai : <span className="capitalize font-bold">Rp {rupiahFormat(paidIncome)}</span></h2>
        </div>
        <div>
          <h2 className="capitalize">Kredit : <span className="capitalize font-bold">Rp {rupiahFormat(creditIncome)}</span></h2>
        </div>
        <div>
          <h2 className="capitalize">Total : <span className="capitalize font-bold">Rp {rupiahFormat(totalIncome)}</span></h2>
        </div>
      </div>
      {isLoading ?
        <div className="h-64 flex flex-col items-center justify-center">
          <Spinner />
          <span>Mohon tunggu...</span>
        </div>
        : <div className="h-full">
          <div>
            <ReusableTable
              data={tableData}
              columns={shippingsTableColumn}
              rowSelection={rowSelection}
              onRowSelectionChange={setRowSelection}
            />
            <Modal
              title="Detail Kiriman"
              isOpen={isOpenDetailsModal}
              disabledButton={isLoading}
              onClose={() => {
                setSelectedShippingData(null);
                setIsOpenDetailsModal(false);
              }}
              showFooter={false}
            >
              <ShippingDetails shippingNumber={selectedShippingData?.shipping_number} />
            </Modal>
          </div>
        </div>
      }
    </div>
  )
}

export default ShippingListTable